/**
 * Copyright 2021 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import Title from '@/components/AZCustomComponent/Title';
import { useLabels } from '@/hooks/useLabels';
import type { OldReview } from '../../interface';
import azCommonStyles from '@/theme/globals.module.scss';
import { BVShelfCard } from './BVShelfCard';
import styles from './styles.module.scss';

const labelMap = {
  titleFirst: 'label_customer',
  titleSecond: 'label_reviews',
};

type Props = {
  reviews: OldReview[];
};

export const BazaarVoiceShelfSection = ({ reviews }: Props) => {
  const labels = useLabels(labelMap);

  return (
    <div
      className={`
        ${azCommonStyles['az-padding-top-m']}
        ${azCommonStyles['az-padding-left-xs']}
        ${azCommonStyles['az-padding-right-xs']}
        ${styles.bvContainer}`}
      data-testid="BazaarVoiceShelf"
    >
      <Title
        firstText={labels.titleFirst}
        secondText={labels.titleSecond}
        swapStyle
        variant="md"
        stylesClass={`${azCommonStyles['az-padding-bottom-4xs']} ${styles.bvTitle}`}
        isSameTitleTag
      />
      <div className={`${azCommonStyles['az-margin-bottom-xxxs']} ${styles.separator}`} />
      {reviews.map((review, index) => (
        <BVShelfCard key={index} review={review} />
      ))}
    </div>
  );
};
